// src/config/firebase.ts

import { initializeApp, FirebaseApp } from 'firebase/app'
import { getAuth, Auth } from 'firebase/auth'
import { getFirestore, Firestore } from 'firebase/firestore'
import { getStorage, FirebaseStorage } from 'firebase/storage'

const firebaseConfig = {
	apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
	authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
	projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
	storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
	messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
	appId: import.meta.env.VITE_FIREBASE_APP_ID,
}

// Check if Firebase config is complete
const isFirebaseConfigured = () => {
	return !!(
		firebaseConfig.apiKey &&
		firebaseConfig.authDomain &&
		firebaseConfig.projectId &&
		firebaseConfig.appId
	)
}

// Initialize Firebase with error handling
let app: FirebaseApp | null = null
let auth: Auth | null = null
let db: Firestore | null = null
let storage: FirebaseStorage | null = null

try {
	if (isFirebaseConfigured()) {
		app = initializeApp(firebaseConfig)
		auth = getAuth(app)
		db = getFirestore(app)
		storage = getStorage(app)
	} else {
		console.warn(
			'Firebase configuration incomplete. Firebase services disabled. Using API authentication.',
		)
	}
} catch (error) {
	console.warn(
		'Firebase initialization failed. Using API authentication fallback.',
		error,
	)
}

// Firebase services - may be null if not configured
export { auth, db, storage }
export default app
